export default __webpack_public_path__ + "static/media/65-min.f693ef36.jpg";